var specialProduct = false;
for (var i = 0; i < crItems.length; i++) {
  var crItem = crItems[0];
  console.log(crItem);
  
}
document.addEventListener('crJQActivated', function (e) {
    var CRexcludeCollections = [];
    var CRmandatoryCollections = [];

    for (var c in storePickupSettings.mandatory_collections) {
        // Some stores have extra functions inside an empty array, this will cause errors, to prevent it we check for undefined
        if(storePickupSettings.mandatory_collections[c].title === undefined) continue;
        CRmandatoryCollections.push(storePickupSettings.mandatory_collections[c].title.replace(/'/g, '&apos;'));
    }
    for (var c in storePickupSettings.exclude_collections) {
        if(storePickupSettings.exclude_collections[c].title === undefined) continue;
        CRexcludeCollections.push(storePickupSettings.exclude_collections[c].title.replace(/'/g, '&apos;'));
    }
  
    for (i = 0; i < CRproductCollections.length; ++i) {
        var value = CRproductCollections[i].innerHTML.replace(/'/g, '&apos;').replace(/&amp;/, '&');
        // If there is an item in the cart exluded from pickup, we'll not display the store pickup option at all
        if (CRexcludeCollections.indexOf(value) > -1) {
            CRexcludedFromPickup = true;
        }
        if (CRmandatoryCollections.indexOf(value) > -1) {
            CRmandatoryForPickup = true;          
          
        }
    }
  
  //jqCR('#delivery-date-start').attr('placeholder', 'Choose a date')
  
  console.log({CRexcludedFromPickup, CRmandatoryForPickup})
  if (CRexcludedFromPickup === true && CRmandatoryForPickup === true) {
    jqCR('#cr-disable-message').css('display', 'block').text('Please note, one or more items in your cart are only available for delivery. Delivery Items are not available for pickup from our Brisbane store. Please remove any delivery items from your cart & checkout separately')
    jqCR('#pickup-container').remove();
    disableCheckoutButton()
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 5000);  
  }
})

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  blackoutdatesCollection.push([2023, 1, 14, 'inverted'])
  blackoutdatesCollection.push([2023, 3, 19, 'inverted'])
  blackoutdatesCollection.push([2023, 4, 14, 'inverted'])
  blackoutdatesCollection.push([2023, 11, 24, 'inverted'])
  // if (specialProduct === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2020, 8, 10], to: [2023, 4, 11] }, 
  //                          { from: [2023, 4, 15], to: [2025, 9, 7] }]);
  //   picker.set('max', 100);   
  // }	else {
    picker.set('disable', blackoutdatesCollection);
  //}  
  
}

// var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
//   console.log(selectedDay, selectedDate, selectedMonth);
//   if(selectedDate.getDate() === 14 && selectedMonth === 1 && selectedDate.getFullYear() === 2024) {
//   	timepicker.set('min',[8, 0]); 
//     timepicker.set('max',[17, 0]); 
//   }

//   if(selectedDate.getDate() === 13 && selectedMonth === 4 && selectedDate.getFullYear() === 2023) {
//   	timepicker.set('min',[8, 0]); 
//     timepicker.set('max',[14, 0]); 
//   }

//   if(selectedDate.getDate() === 14 && selectedMonth === 4 && selectedDate.getFullYear() === 2023) {
  
    
//   	timepicker.set('min',[10, 0]); 
//     timepicker.set('max',[13, 0]); 
//   }
// }

var crAfterDateSelectedCallback = function(selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log({selectedDay})
  var t = selectedDate;
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentyear = t.getFullYear();
  var weekDay = t.getDay();
  var currentHour = t.getHours()

  console.log({weekDay, currentMonth})
  if (weekDay === 0) {
    window.maxOrdersPerTimeSlot = 3;
  } 
  if (weekDay === 1) {
    window.maxOrdersPerTimeSlot = 5;
  } 
  if (currentDay === 14 && currentMonth === 1 && currentyear === 2025) {
    window.maxOrdersPerTimeSlot = 20;
  }/* else {
    // Tuesday
    if (selectedDay === 2) {
      window.maxOrdersPerTimeSlot = 3;
    }
    
    // Wednesday
    if (selectedDay === 3) {
      window.maxOrdersPerTimeSlot = 2;
    }
  
    // Thursday
    if (selectedDay === 4) {
      window.maxOrdersPerTimeSlot = 2;
    }
  
    // Friday
    if (selectedDay === 5) {
      window.maxOrdersPerTimeSlot = 3;
    }
  
    // Saturday
    if (selectedDay === 6) {
      window.maxOrdersPerTimeSlot = 4;
    }
  }*/
  
	// if((selectedDate.getDate() === 14 && selectedMonth === 4 && selectedDate.getFullYear() === 2023)     ) {
 //      window.maxOrdersPerTimeSlot = 0;
 //  }
}